import Plugin, { init } from "@/modules/_utils/Plugin";
import $ from "jquery";
window.jQuery = $;

class AccountModal extends Plugin {
  init() {
    $(".new-address").on("click", function() {
      $("body").addClass("account__modal-active");
      $(".account__modal-content").addClass("address-form");
    });

    $(".new-billing-address").on("click", function() {
      $("body").addClass("account__modal-active");
      $(".account__modal-content").addClass("billing-form");
    });

    $(".account__modal-content_close").on("click", function() {
      $("body").removeClass("account__modal-active");
      $(".account__modal-content").removeClass("billing-form");
      $(".account__modal-content").removeClass("address-form");
    });
  }
}

export default init(AccountModal, "accountModal");
